import React, { useState, useEffect } from "react";

const ProfilesTableLimits = ({
  profiles,
  filterInput,
  setFilterInput,
  setProfileOptionSelected,
  profileOptionSelected,
  setProfileName,
  setBetTypeOptionSelected,
  setBetTypeName,
}) => {
  const [filteredData, setFilteredData] = useState([]);

  //This useEffect filters the Tracks table according to Book Description.
  useEffect(() => {
    let filteredData = profiles;
    //Books input filter
    if (filterInput) {
      filteredData = filteredData.filter((item) =>
        item.ProfileName.toLowerCase().includes(filterInput.toLowerCase()),
      );
    }
    setFilteredData(filteredData);
  }, [profiles, filterInput]);

  // Headers
  let headers,
    profilesTable = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDProfile</th>
      <th>Profile </th>
    </tr>
  );

  // The main Profiles table
  if (profiles) {
    profilesTable = filteredData.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.ProfileID}
            onClick={() =>
              handleProfileChange(item.ProfileID, item.ProfileName)
            }
            className={
              profileOptionSelected === item.ProfileID ? "shadedRow" : ""
            }
            style={{ cursor: "pointer" }}
          >
            <td key={"ProfileID" + i} className="d-none">
              {item.ProfileID}
            </td>
            {/* Profile Name */}
            <td
              key={"Description" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "180px",
                maxWidth: "180px",
              }}
            >
              <div
                title={item.ProfileName}
                style={{
                  maxWidth: "180px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  fontSize: "14px",
                }}
              >
                {item.ProfileName}
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  // This constant is used internally to set the selected Track Name or Track Code in the filters
  const handleInputFilterChange = (event) => {
    setFilterInput(event.target.value);
  };

  // This function displays the tracks associated with each book
  const handleProfileChange = (idProfile, profileName) => {
    setProfileOptionSelected(idProfile);
    setProfileName(profileName);
    setBetTypeOptionSelected(0);
    setBetTypeName("Win");
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Profile List
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <input
          value={filterInput}
          onChange={handleInputFilterChange}
          placeholder={"Profile Search..."}
          className="form-control mb-1"
        />
      </div>
      <div
        className="tablesLimits"
        style={{
          overflow: "auto",
        }}
      >
        <table className="table table-hover table-sm mt-2">
          <thead
            style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{profilesTable}</tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfilesTableLimits;
